import { z } from 'zod';

import { ResourceTriggerCriteria } from './criteria.js';
import { ResourceEventFlowTriggerState } from '../flow/flowTrigger.js';

export const FlowRunOption = z.enum(['OnlyPublishedRuns', 'AllRuns']);
export type FlowRunOption = z.infer<typeof FlowRunOption>;

/** Only used when resourceFirstArchitectureDemo flag is on */
export const ResourceFlowTriggerSchema = z.object({
  id: z.uuid(),
  organizationId: z.uuid(),
  flowId: z.uuid(),
  resourceKey: z.string(),
  eventType: z.array(z.enum(['created', 'updated', 'deleted'])),
  criteria: ResourceTriggerCriteria,
  contextPaths: z.array(z.string()).nullable(),
  state: ResourceEventFlowTriggerState,
  flowRunOption: FlowRunOption,
  created: z.string().datetime(),
  updated: z.string().datetime(),
  deleted: z.string().datetime().nullable(),
});
export type ResourceFlowTrigger = z.infer<typeof ResourceFlowTriggerSchema>;

export interface CreateResourceFlowTrigger {
  flowId: string;
  organizationId: string;
  resourceKey: string;
  eventType: ('created' | 'updated' | 'deleted')[];
  criteria?: ResourceTriggerCriteria;
  contextPaths?: string[] | null;
  state?: Exclude<ResourceEventFlowTriggerState, 'SoftDeleted'>;
  flowRunOption?: FlowRunOption;
}

export interface UpdateResourceFlowTrigger {
  resourceKey?: string;
  eventType?: ('created' | 'updated' | 'deleted')[];
  criteria?: ResourceTriggerCriteria;
  contextPaths?: string[] | null;
  state?: ResourceEventFlowTriggerState;
  flowRunOption?: FlowRunOption;
}

export interface ResourceFlowTriggerFindAllOptions {
  flowId: string;
}
